import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { take } from 'rxjs/operators';

/**
 * SVG icon service: Handles caching / loading
 */
@Injectable({
  providedIn: 'root'
})
export class SvgIconService {
  /**
   * SVG cache to prevent loading multiple times
   */
  private static svgCache: Map<string, any> = new Map<string, any>();

  /**
   * SVG load promises cache to prevent loading multiple times
   */
  private static requestsCache: Map<string, Observable<any>> = new Map<string, Observable<any>>();

  /**
   * Constructor
   * @param http HttpClient
   */
  constructor(private http: HttpClient) { }

  /**
   * Loads an SVG icon
   * @param source The source / url. Use URLs like './assets/icons/caret-up-outline.svg', not like '../../../assets/icons/caret-up-outline.svg'
   * @returns A Promise to wait for
   */
  public loadSvg(source: string): Promise<string> {
    return new Promise<string>((resolve) => {
      //Already cached?
      if (SvgIconService.svgCache.has(source)) {
        resolve(SvgIconService.svgCache.get(source));
      } else {
        //Was the request already fired?
        let observable$ = null;
        if (SvgIconService.requestsCache.has(source)) {
          observable$ = SvgIconService.requestsCache.get(source);
        } else {
          observable$ = from(new Promise<any>((resolveInner) => {
            this.http.get(source, { responseType: 'text' }).pipe(take(1)).subscribe((svg) => {
              if (svg) {
                //Put to cache, so the Observable isn't needed any more
                SvgIconService.svgCache.set(source, svg);
                SvgIconService.requestsCache.set(source, null);
              }
              resolveInner(svg);
            });
          }));
          SvgIconService.requestsCache.set(source, observable$);
        }
        observable$.pipe(take(1)).subscribe(svg => {
          resolve(svg);
        });
      }
    });
  }
}
